"use client";

import { BackButton } from "@/components/BackButton";
import { Button } from "@/components/ui/button";
import { pagesPath } from "@/utils/pages-path";
import Link from "next/link";
import type { FC } from "react";

export const EmailAlreadyRegisteredView: FC<{
  onBack: () => void;
}> = ({ onBack }) => {
  return (
    <div className="flex flex-col items-center gap-14">
      <div className="flex w-full flex-col gap-14">
        <h2 className="text-center text-lg font-bold text-error">
          このメールアドレスは
          <br className="sm:hidden" />
          すでに登録されています
        </h2>
        <p className="text-sm text-monotone-7">
          このメールアドレスはすでに登録されています。本人確認を完了してください。
        </p>
      </div>
      <div className="flex w-full flex-col items-center gap-4">
        <Button className="w-full" variant="primary" size="lg" asChild>
          <Link href={pagesPath.members.verify_account.$url().path}>
            本人確認をする
          </Link>
        </Button>
        <BackButton label="前に戻る" onClick={onBack} />
      </div>
    </div>
  );
};
